var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mailType2"}},[_c('div',{staticClass:"startingEndPoint"},[_c('StartingEndPoint')],1),_c('BoxList'),_c('div',{staticClass:"size"},[_c('Size',{attrs:{"boxType":"02"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }